/* eslint-disable react-hooks/exhaustive-deps */
// ** React Imports
import { useState, useEffect } from 'react'

// ** MUI Imports
import Box from '@mui/material/Box'
import List from '@mui/material/List'
import Chip from '@mui/material/Chip'
import Badge from '@mui/material/Badge'
import Drawer from '@mui/material/Drawer'
import ListItem from '@mui/material/ListItem'
import Typography from '@mui/material/Typography'
import ListItemText from '@mui/material/ListItemText'
import ListItemButton from '@mui/material/ListItemButton'
import InputAdornment from '@mui/material/InputAdornment'
import { useTheme } from '@mui/material/styles';

// ** Third Party Components
import PerfectScrollbar from 'react-perfect-scrollbar'

// ** Icon Imports
import Icon from '../../../@core/components/icon'

// ** Custom Components Import
import CustomTextField from '../../../@core/components/mui/text-field'
import { TabContext, TabList } from '@mui/lab'
import { Checkbox, MenuItem, Popover, Tab } from '@mui/material'

const ScrollWrapper = ({ children, hidden }) => {
  if (hidden) {
    return <Box sx={{ height: '76vh', overflow: 'auto' }}>{children}</Box>
  } else {
    return <PerfectScrollbar style={{ minHeight: '75vh', maxHeight: '76vh' }} options={{ wheelPropagation: false }}>{children}</PerfectScrollbar>
  }
}

const SidebarLeft = props => {
  // ** Props
  const {
    hidden,
    mdAbove,
    sidebarWidth,
    leftSidebarOpen,
    handleLeftSidebarToggle,
    count,
    statusTab,
    setStatusTab,
    type,
    handleChanges,
    pendingUserList,
    completeUserList,
    notCompleteUserList,
    pendingTotalCount,
    completeTotalCount,
    notCompleteTotalCount,
    selectedCompanyName,
    setSelectedCompanyName,
    setLoadingById
  } = props

  // ** States
  const [query, setQuery] = useState('')

  // const [selectedAccount, setSelectedAccount] = useState('')
  const [accountData, setAccountData] = useState([])
  const [isOpenPopover, setIsOpenPopover] = useState(null);
  const [selectedValues, setSelectedValues] = useState(''); // Store selected options
  const [sort, setSort] = useState('DESC')
  const [filterData, setFilterData] = useState(null)

  const theme = useTheme(); // Get the theme object

  const handleToggle = (value) => {
    if (value === selectedValues) {
      setSelectedValues('')
    } else {
      setSelectedValues(value);
    }
  };

  // ** Hooks
  // const router = useRouter()
  const options = ['All', 'Platform', 'Trueseller'];

  const handleOpenMenu = (event) => {
    setIsOpenPopover(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setIsOpenPopover(null);
  };

  const handleChange = (event, newValue) => {
    setStatusTab(newValue)
  }

  const handleChatClick = (type, id, selectedCompanyName, truesellerAccount) => {
    setLoadingById(true)
    handleChanges({ statusTab, type, gstId: id, size: 50, page: 0 }, selectedCompanyName, truesellerAccount)
    handleActiveAccountShow()
  }
  const activeCondition = false

  useEffect(() => {
    if (query) {
      handleActiveAccountShow()
    }
  }, [statusTab, accountData])

  const getRecord = () => {
    if (statusTab === 'PENDING') {
      setAccountData(pendingUserList)
    } else if (statusTab === 'COMPLETED') {
      setAccountData(completeUserList)
    } else {
      setAccountData(notCompleteUserList)
    }
  }

  useEffect(() => {
    getRecord()
  }, [statusTab, count])


  const handleSorting = (sortType) => {
    setSort(sortType)

    if (query) {
      const sortedData = filterData.sort((a, b) =>
        sortType === 'ASC' ? a.count - b.count : b.count - a.count
      );
      setFilterData(sortedData)
    } else {
      const sortedData = accountData.sort((a, b) =>
        sortType === 'ASC' ? a.count - b.count : b.count - a.count
      );
      setAccountData(sortedData)
    }
  }

  const clearFilters = () => {
    setQuery('')
    setSelectedValues('')
    handleCloseMenu()
    getRecord()
    setSelectedCompanyName('')
  }

  const handleActiveAccountShow = () => {
    if (query) {
      let filterData = accountData.filter(item =>
        (item.email && item.email.toLowerCase().includes(query)) ||
        (item.platformEmail && item.platformEmail.toLowerCase().includes(query))
      )
      setTimeout(() => {
        setFilterData(filterData)
      }, 300);
    }
  }

  const handleFilter = e => {
    setQuery(e.target.value)
    let filterData
    if (e.target.value) {
      if (accountData && accountData.length > 0) {
        if (selectedValues) {
          if (selectedValues === 'Platform') {
            filterData = accountData.filter(item =>
              (item.platformEmail && item.platformEmail.toLowerCase().includes(e.target.value.toLowerCase()))
            )
          }
          else if (selectedValues === 'Trueseller') {
            filterData = accountData.filter(item =>
              (item.email && item.email.toLowerCase().includes(e.target.value.toLowerCase()))
            )
          } else {
            filterData = accountData.filter(item =>
              (item.email && item.email.includes(e.target.value.toLowerCase())) ||
              (item.platformEmail && item.platformEmail.toLowerCase().includes(e.target.value.toLowerCase()))
            )
          }
        } else {
          filterData = accountData.filter(item =>
            (item.email && item.email.toLowerCase().includes(e.target.value.toLowerCase())) ||
            (item.platformEmail && item.platformEmail.toLowerCase().includes(e.target.value.toLowerCase()))
          )
        }
      }
      setFilterData(filterData)

      // setAccountData(filterData)
    } else {
      getRecord()
    }
  }

  const typeofClaim = () => {
    switch (type) {
      case 'CUSTOMER_RETURN':
        return <span className='chip_chat_content'> Wrong</span>
      case 'RTO_RETURN':
        return <span className='chip_chat_content'> Wrong Rto</span>
      case 'NON_BARCODED_RTO':
        return <span className='chip_chat_content' style={{ border: 0, fontSize: "10px" }}> Non Barcoded Rto </span>
      case 'Damage':
        return <span className='chip_chat_content'> Damaged Return</span>
      case 'MISSING_QTY':
        return <span className='chip_chat_content'> Missing Qty</span>
      default:
        return null;
    }
  }

  return (
    <div>
      <Drawer
        open={leftSidebarOpen}
        onClose={handleLeftSidebarToggle}
        variant={mdAbove ? 'permanent' : 'temporary'}
        ModalProps={{
          disablePortal: true,
          keepMounted: true // Better open performance on mobile.
        }}
        sx={{
          zIndex: 7,
          height: '100%',
          display: 'block',
          position: mdAbove ? 'static' : 'absolute',
          '& .MuiDrawer-paper': {
            boxShadow: 'none',
            width: sidebarWidth,
            position: mdAbove ? 'static' : 'absolute',
            borderTopLeftRadius: theme => theme.shape.borderRadius,
            borderBottomLeftRadius: theme => theme.shape.borderRadius
          },
          '& > .MuiBackdrop-root': {
            borderRadius: 1,
            position: 'absolute',
            zIndex: theme => theme.zIndex.drawer - 1
          }
        }}
      >
        <Box
          sx={{
            pt: 2,
            px: 2,
            display: 'flex',
            alignItems: 'center',
            justifyContent: "center",
            borderBottom: theme => `1px solid ${theme.palette.divider}`
          }}
        >
          <TabContext value={statusTab}>
            <TabList onChange={handleChange} aria-label='customized tabs example'>
              <Tab
                value='PENDING'
                label={
                  <Box display="flex" alignItems="center" gap={1}>
                    Pending
                    <Chip label={pendingTotalCount || 0} size="small" color="primary" style={{ height: '20px' }} sx={{
                      height: '20px',
                      '& .MuiChip-label': {
                        fontSize: '11px',  // Example: Change font size
                        color: 'white',     // Example: Change text color
                        padding: "5px"
                      }
                    }} />
                  </Box>
                }
                style={{ padding: "0 4px", fontSize: "12px" }}
              />
              <Tab value='COMPLETED' label={
                <Box display="flex" alignItems="center" gap={1}>
                  Completed <Chip label={completeTotalCount || 0} size="small" color="primary" sx={{
                    height: '17px',
                    '& .MuiChip-label': {
                      fontSize: '11px',
                      color: 'white',
                      padding: "5px"
                    }
                  }} />
                </Box>
              } style={{ padding: "0 8px", fontSize: "12px" }} />
              <Tab value='CLAIM_NOT_SUBMITTED' label={
                <Box display="flex" alignItems="center" gap={1}>
                  Failed <Chip label={notCompleteTotalCount || 0} size="small" color="primary" sx={{
                    height: '20px',
                    '& .MuiChip-label': {
                      fontSize: '11px',  // Example: Change font size
                      color: 'white',     // Example: Change text color
                      padding: "5px"
                    }
                  }} />
                </Box>
              }
                style={{ padding: "0 8px", fontSize: "12px" }} />
            </TabList>
          </TabContext>
        </Box>
        <Box sx={{ mt: 2, px: 3, position: "relative", boxShadow: "rgb(33 35 38 / 59%) 0px 10px 10px -10px" }}>
          <CustomTextField
            fullWidth
            value={query}
            width="100%"
            onChange={handleFilter}
            placeholder='Search for contact...'
            sx={{ '& .MuiInputBase-root': { borderRadius: '30px !important', width: "100%", padding: "0 5px" } }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" sx={{ color: 'text.secondary' }}>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer', background: theme.palette.grey[200], borderRadius: "50%", padding: "5px" }}
                    onClick={handleOpenMenu} // Open dropdown on click
                  >
                    {selectedValues ?
                      <Badge badgeContent={1} color='primary'>
                        <Icon icon="material-symbols:menu" width="20" height="20" />
                      </Badge>
                      :
                      <Icon icon="material-symbols:menu" width="20" height="20" />

                    }
                  </Box>
                </InputAdornment>
              ),
              endAdornment: ( // Icon at the end
                <InputAdornment position="end" sx={{ color: 'text.secondary' }}>
                  <Box
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, background: theme.palette.grey[200], borderRadius: "50%", padding: "5px" }}
                  >
                    {filterData && query && <span className='searchbadge'>{filterData.length}</span>}
                    <Icon fontSize="1.25rem" icon="tabler:search" width="20" height="20" />
                  </Box>
                </InputAdornment>
              )
            }}
          />
        </Box>
        <Box sx={{ height: `calc(100% - 4.0625rem)` }}>
          <ScrollWrapper hidden={hidden}>
            <Box sx={{ p: theme => theme.spacing(3, 0, 3) }}>
              <div style={{ display: "flex", justifyContent: "space-between", padding: '10px 10px', backgroundColor: '#4fc483' }}>
                <Typography variant='h6' sx={{ color: 'common.white', fontWeight: 600 }}>
                  {type.toLowerCase().replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())}  {typeofClaim()}
                </Typography>
                {sort === 'DESC' ?
                  <Icon icon="fa6-solid:arrow-down-9-1" style={{ color: 'white' }} width="20" height="20" onClick={() => handleSorting("ASC")} />
                  :
                  <Icon icon="fa6-solid:arrow-up-1-9" style={{ color: 'white' }} width="20" height="20" onClick={() => handleSorting("DESC")} />
                }

              </div>
              {(query && filterData ? filterData : accountData ?? []).length > 0 ? (
                (query && filterData ? filterData : accountData ?? []).map((data, index) => {
                  return (
                    <List
                      sx={{
                        p: 0,
                        boxShadow: "rgba(149, 157, 165, 0.23) 0px 8px 24px",
                        bgcolor: (theme) =>
                          data.companyName === selectedCompanyName ? '#fff5dc' : "white",
                        borderBottom: (theme) =>
                          data.companyName === selectedCompanyName ? '2px solid #ffc107' : ''
                      }}
                      key={index}
                    >
                      <ListItem disablePadding sx={{ '&:not(:last-child)': { mb: 1 } }}>
                        <ListItemButton
                          disableRipple
                          onClick={() => handleChatClick(type, data.id, data.companyName, data.platformEmail)}
                          sx={{
                            py: 2,
                            pr: 2,
                            pl: 0,
                            width: '100%',
                            borderRadius: 1,
                            alignItems: 'flex-start',
                            '&.MuiListItemButton-root:hover': { backgroundColor: 'action.hover' },
                          }}
                        >
                          <ListItemText
                            sx={{
                              my: 0,
                              ml: 3,
                              mr: 1.5,
                              '& .MuiTypography-root': { ...(activeCondition && { color: 'common.black' }) }
                            }}
                            primary={
                              <Typography noWrap variant='h6' style={{ fontWeight: "600" }} sx={{
                                color: (theme) =>
                                  data.companyName === selectedCompanyName
                                    ? 'text.themeColor'
                                    : "rgb(93 90 104)",
                              }}>
                                {data.platformEmail}
                              </Typography>
                            }
                            secondary={
                              <>
                                <Typography noWrap variant='body2' sx={{ ...(!activeCondition && { color: 'text.secondary' }) }}>
                                  {data.email}
                                </Typography>
                                <Typography noWrap variant='body2' sx={{ ...(!activeCondition && { color: 'text.secondary' }) }}>
                                  {data.companyName}
                                </Typography>
                              </>
                            }
                          />
                          <Box
                            sx={{
                              display: 'flex',
                              alignItems: 'flex-end',
                              flexDirection: 'column',
                              justifyContent: 'flex-start'
                            }}
                          >
                            <Chip
                              label={data.count}
                              sx={{
                                mt: 0.5,
                                height: 18,
                                fontWeight: 600,
                                fontSize: '0.75rem',
                                background: '#cf8717',
                                color: "white",
                                '& .MuiChip-label': { pt: 0.25, px: 1.655 }
                              }}
                            />
                          </Box>
                        </ListItemButton >
                      </ListItem >
                    </List>
                  )
                })
              ) : (
                <Typography variant="body1" sx={{ textAlign: 'center', color: 'text.secondary', mt: 2 }}>
                  No records found.
                </Typography>
              )}

            </Box>
          </ScrollWrapper>
        </Box>
        <Popover
          open={Boolean(isOpenPopover)}
          anchorEl={isOpenPopover}
          onClose={handleCloseMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          {options.map((option) => (
            <MenuItem key={option} onClick={() => handleToggle(option)} style={{ padding: '8px 5px 8px 0', margin: "2px 5px" }}>
              <Checkbox checked={selectedValues === option} style={{
                padding: "0px", margin: "2px 5px", height: "15px", width: "20px"
              }} />
              <ListItemText primary={option} style={{ fontSize: "12px" }} />
            </MenuItem>
          ))}
          <MenuItem onClick={() => clearFilters()} style={{ padding: '8px 5px', margin: "2px 5px", color: '#EA5455' }}>
            Reset
          </MenuItem>
        </Popover>
      </Drawer>
    </div >
  )
}

export default SidebarLeft
